@switch (variante()) {
@case ('simples') {
<nav class="paginacao-simples" [attr.aria-label]="rotulo()">
  @if (resumo()) {
  <span class="paginacao-simples-resumo">{{ resumo() }}</span>
  }

  <div class="paginacao-simples-paginas">
    @for (pagina of paginas(); track pagina) {
    <button type="button" class="paginacao-simples-pagina" [class.paginacao-simples-pagina-ativa]="pagina === paginaAtual()"
      [attr.aria-current]="pagina === paginaAtual() ? 'page' : null" (click)="irParaPagina(pagina)">
      {{ pagina }}
    </button>
    }
  </div>

  <ng-content></ng-content>
</nav>
}

@default {
<nav class="paginacao" [attr.aria-label]="rotulo()">
  <span class="paginacao-confete paginacao-confete-circulo paginacao-confete-1" aria-hidden="true"></span>
  <span class="paginacao-confete paginacao-confete-triangulo paginacao-confete-2" aria-hidden="true"></span>
  <span class="paginacao-confete paginacao-confete-circulo paginacao-confete-3" aria-hidden="true"></span>
  <span class="paginacao-confete paginacao-confete-triangulo paginacao-confete-4" aria-hidden="true"></span>
  <span class="paginacao-confete paginacao-confete-circulo paginacao-confete-5" aria-hidden="true"></span>

  <div class="paginacao-barra">
    <p class="paginacao-status" role="status">
      Página {{ paginaAtual() }} de {{ totalPaginas() }}
    </p>

    <button type="button" class="paginacao-botao paginacao-anterior" [disabled]="!temPaginaAnterior()"
      (click)="paginaAnterior()">
      <span class="paginacao-enfeites" aria-hidden="true">
        <span class="paginacao-enfeite-circulo paginacao-vermelho"></span>
        <span class="paginacao-enfeite-triangulo paginacao-amarelo"></span>
        <span class="paginacao-enfeite-circulo paginacao-verde"></span>
      </span>

      <span class="paginacao-setas" aria-hidden="true">&lsaquo;&lsaquo;&lsaquo;</span>
      Voltar
    </button>

    <button type="button" class="paginacao-botao paginacao-proximo" [disabled]="!temProximaPagina()"
      (click)="proximaPagina()">
      <span class="paginacao-enfeites" aria-hidden="true">
        <span class="paginacao-enfeite-triangulo paginacao-vermelho"></span>
        <span class="paginacao-enfeite-circulo paginacao-amarelo"></span>
        <span class="paginacao-enfeite-triangulo paginacao-verde"></span>
      </span>

      Próximo
      <span class="paginacao-setas" aria-hidden="true">&rsaquo;&rsaquo;&rsaquo;</span>
    </button>
  </div>
</nav>
}
}
